import { render } from "./PassportInfo.vue?vue&type=template&id=9a38ea64"
import script from "./PassportInfo.vue?vue&type=script&lang=js"
export * from "./PassportInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PassportInfo.vue?vue&type=style&index=0&id=9a38ea64&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__